// Админ-API настроек JivoChat (Tech-Story-jivo-admin-settings, R-FE-1; канон email.ts).
// Контракт (backend JivoSettingsAdminDto §R-BE-6):
//   - GET /api/admin/jivo/settings → JivoSettingsAdmin (секрет не возвращается — hasSecret + маска);
//   - PUT /api/admin/jivo/settings → JivoSettingsAdmin (+newWebhookSecret один раз при смене).

import { apiClient } from '@/api/client';

/**
 * Маска секрета (канон SMTP «••••••••»); зеркалит BE {@link JivoSettingsService.SECRET_MASK}
 * (R3 fix F5b: единственный экземпляр литерала в пределах фичи).
 */
export const JIVO_SECRET_MASK = '••••••••';

/** Настройки JivoChat (wire JivoSettingsAdminDto): секрет write-only, значения в DTO нет. */
export interface JivoSettingsAdmin {
  enabled: boolean;
  widgetId: string | null;
  crmBaseUrl: string | null;
  /** Секрет вебхука сохранён (значение наружу не отдаётся никогда). */
  hasSecret: boolean;
  /** Маска секрета (канон SMTP): «••••••••» при hasSecret, иначе null. */
  secretMask: string | null;
  updatedAt: string | null;
  /** Одноразово в PUT-ответе при смене секрета; в GET — всегда null. */
  newWebhookSecret?: string | null;
}

/** Тело PUT /api/admin/jivo/settings. */
export interface JivoSettingsUpdateRequest {
  enabled: boolean;
  /** null/undefined → NULL в БД (fallback на env app.jivo.widget-id). */
  widgetId?: string | null;
  /** null/undefined → NULL в БД (fallback на env app.jivo.webhook.crm-base-url). */
  crmBaseUrl?: string | null;
  /**
   * Опущено/undefined — «оставить прежний» (канон SmtpAccountDialog §3.5: FE при
   * пустом поле ОПУСКАЕТ поле). Пустая строка "" НЕ допустима — BE отклоняет 400
   * validation_failed (контракт синхронизирован с @Size(min=16) JivoSettingsUpdateRequest).
   */
  webhookSecret?: string;
}

/** Админ-клиент настроек JivoChat (запросы через общий apiClient с JWT). */
export const jivoSettingsApi = {
  /** GET /api/admin/jivo/settings → текущие настройки (секрет — только hasSecret + маска). */
  async get(): Promise<JivoSettingsAdmin> {
    const { data } = await apiClient.get<JivoSettingsAdmin>('/api/admin/jivo/settings');
    return data;
  },

  /** PUT /api/admin/jivo/settings → обновлённые настройки (+newWebhookSecret при смене секрета). */
  async update(body: JivoSettingsUpdateRequest): Promise<JivoSettingsAdmin> {
    const { data } = await apiClient.put<JivoSettingsAdmin>('/api/admin/jivo/settings', body);
    return data;
  },
};
